/** Service Desk console: Ticket workspace (C02, SD-S1-44), Filipino. Same keys as `en/service-ticket-detail.ts` (a test enforces it). */
export const serviceTicketDetail = {
  label: "Ticket",
  loading: "Nilo-load ang ticket",
  missing: {
    title: "Hindi nakita ang {{number}}",
    body: "Maaaring pinagsama na ito, o wala kang access dito. Bumalik sa listahan para hanapin ito.",
  },
  error: {
    title: "Hindi namin ma-load ang ticket na ito",
    body: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago.",
  },
  errors: {
    invalidTransition: "Hindi pinapayagan ang paglipat na iyon sa ticket na ito ngayon. Nakalista sa menu ng status ang mga puwede.",
    fieldsRequired: "May mga kinakailangang field na walang laman: {{keys}}.",
    mergeOtherOrg: "Magkaibang organisasyon ang mga ticket na ito, kaya hindi sila mapagsasama.",
  },
  bar: {
    back: "Mga Ticket",
    move: "Lumipat sa ibang ticket",
    previous: "Nakaraang ticket (k)",
    next: "Susunod na ticket (j)",
    position: "{{position}} sa {{count}}",
    positionOpen: "{{count}} ang bukas",
    positionMore: "{{count}}+ ang bukas",
    live: { connecting: "Kumokonekta", live: "Live", reconnecting: "Muling kumokonekta" },
  },
  queue: {
    label: "Pila ng mga ticket",
    title: "Pila",
    count: "{{count}} ang bukas · pinakamadalian muna",
  },
  head: {
    copy: "Kopyahin ang numero ng ticket",
    copied: "Nakopya ang {{number}}",
    unverified: "Hindi pa verified ang humihiling",
    unassigned: "Walang may-ari",
    viewing: "Tinitingnan ni {{name}}",
    viewingMany: "Tinitingnan ni {{name}} at ng {{count}} pa",
    merge: "Pagsamahin",
    resolve: "Ayusin",
    more: "Iba pang aksyon",
    watched: "Binabantayan mo na ang {{number}}: matatanggap mo ang mga update nito",
    unwatched: "Itinigil mo na ang pagbabantay sa {{number}}",
    moreMenu: { link: "Mag-link ng ticket", watch: "Bantayan ang ticket", unwatch: "Itigil ang pagbabantay", cancel: "Isara bilang kinansela…" },
    priority: {
      button: "Priyoridad: {{priority}}. Palitan ang priyoridad",
      menu: "Itakda ang priyoridad",
      changed: "Naitakda ang priyoridad sa {{priority}}. Kinalkula ulit ang mga target ng SLA.",
    },
    status: {
      button: "Status: {{status}}. Palitan ang status",
      menu: "Palitan ang status",
      menuTitle: "Ilipat sa (mga balidong paglipat lang)",
      none: "Walang puwedeng lipatan mula sa “{{status}}”. Ang sagot ng kliyente sa saradong ticket ay gagawa ng follow-up ticket.",
      clientSees: "Makikita ng kliyente ang “{{label}}”",
      notified: "naabisuhan ang kliyente",
      notAnnounced: "hindi ipinaaalam",
      needsReply: "Magpadala muna ng pampublikong sagot",
      needsManage: "Kailangan ang pahintulot na mamahala ng mga ticket",
      resolveHint: "Hihingi ng resolution code",
      cancelHint: "Hihingi ng dahilan",
      moved: "Naitakda ang status sa {{status}}",
    },
  },
  sla: {
    label: "Mga orasan ng SLA",
    none: "Walang target ng SLA ang ticket na ito",
    target: "Target: {{target}}",
    dueAt: "Takdang oras: {{due}}",
    used: "{{used}} na ng oras ang nagamit",
    warnsAt: "Nagbababala sa {{percent}}% ng oras",
    pausedWhy: "Naka-pause: {{reason}}",
  },
  banners: {
    mergedTitle: "Pinagsama sa {{number}}.",
    mergedTitleUnknown: "Pinagsama sa ibang ticket.",
    mergedBody: "Read-only na ang ticket na ito. Kinopya ang mga mensahe nito sa kabilang ticket at idinagdag ang humihiling bilang kalahok.",
    mergedOpen: "Buksan ang {{number}}",
    closedTitle: "Sarado na.",
    closedBody: "Read-only na ang ticket na ito. Ang sagot ng kliyente sa loob ng 30 araw ay gagawa ng follow-up ticket na naka-link dito.",
    unverifiedTitle: "Hindi pa verified ang humihiling.",
    unverifiedBody: "Hindi pa na-verify ni {{name}} ({{email}}) ang e-mail address na ito, kaya walang organisasyon, asset o kasaysayan ng order sa ticket na ito. Sa address na iyon lang mapupunta ang mga sagot.",
    noEmail: "walang e-mail",
    verifyPhone: "Markahang verified (tawag sa telepono)",
    verifyTitle: "Markahang verified sa telepono?",
    verifyBody: "Kinukumpirma mong nakausap mo si {{name}} at nasuri kung sino siya. Itatala ito sa audit log at aalisin ang babala.",
    verifyConfirm: "Markahang verified",
    verified: "Namarkahang verified ang humihiling",
    breachedTitle: "Lumampas ang SLA.",
    breachedBody: "Lumampas sa target ang {{metrics}}. Nasa activity timeline ang paglampas.",
    resolvedTitle: "Naayos na, hinihintay ang kumpirmasyon ni {{name}}.",
    resolvedBody: "Kusang magsasara ang ticket kung hindi siya sasagot.",
    reopen: "Buksan ulit",
    collisionViewing: "Tinitingnan ni {{names}} ang ticket na ito",
    collisionTyping: "Tinitingnan ni {{names}} ang ticket na ito at nagta-type ng sagot",
    collisionBody: "Basahin muna ang usapan bago magpadala, para hindi dalawang beses masagot.",
    dismiss: "Isara",
  },
  tabs: { label: "Mga tanaw ng ticket", conversation: "Usapan", activity: "Aktibidad", source: "Orihinal na chat" },
  filter: {
    label: "I-filter ang usapan",
    all: "Lahat",
    public: "Mga pampublikong sagot",
    internal: "Mga internal note",
    system: "Sistema",
    note: "Hindi umaabot sa kliyente ang mga internal note.",
  },
  summary: {
    title: "Buod ng AI",
    staffOnly: "para sa staff lang",
    generated: "ginawa {{when}}",
  },
  timeline: {
    client: "Kliyente",
    staff: "Staff",
    assistant: "Assistant",
    publicChip: "Pampublikong sagot",
    internalChip: "Internal note · staff lang",
    replyBy: "Sagot mula kay {{name}}",
    noteBy: "Internal note mula kay {{name}}",
    unknownAuthor: "Hindi kilala",
    someone: "isang kasamahan",
    edited: "na-edit",
    removed: "Inalis ng staff ang mensaheng ito.",
    files: "Mga file na ipinadala kasama ng mensaheng ito",
    openFile: "Buksan ang {{name}}",
    openFileFailed: "Hindi mabuksan ang file. Subukan ulit.",
    quote: "I-quote",
    emptyTitle: "Walang mensaheng tumutugma sa filter na ito",
    emptyBody: "Lumipat sa Lahat para makita ang lahat ng nasa ticket.",
    showAll: "Ipakita lahat",
    errorTitle: "Hindi namin ma-load ang usapan",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago.",
  },
  activity: {
    title: "Timeline ng aktibidad",
    note: "Ito ang sariling kasaysayan ng ticket, hindi ang audit log ng workspace.",
    emptyTitle: "Wala pang aktibidad",
    emptyBody: "Lalabas dito ang mga pagbabago sa ticket (status, may-ari, SLA, tag).",
    errorTitle: "Hindi namin ma-load ang aktibidad",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago.",
  },
  source: {
    title: "Nagsimula ang ticket na ito sa isang chat",
    body: "Nasa Inbox ang usapan sa assistant. Buksan ito roon para mabasa ang napag-usapan bago ginawa ang ticket.",
    open: "Buksan ang usapan",
  },
  events: {
    ticket_created: "Ginawa ang ticket.",
    route_applied: "Na-route ng “{{source}}”.",
    route_applied_plain: "Na-route sa isang team.",
    status_changed: "Status: {{from}} → {{to}}.",
    status_changed_code: "Status: {{from}} → {{to}} (resolution: {{code}}).",
    assignee_changed: "Itinalaga kay {{to}}.",
    assignee_changed_none: "Ibinalik sa pila.",
    team_changed: "Napalitan ang team.",
    priority_changed: "Priyoridad {{from}} → {{to}}. Kinalkula ulit ang mga target ng SLA.",
    type_changed: "Napalitan ang uri ng ticket.",
    title_changed: "Na-edit ang pamagat.",
    description_changed: "Na-edit ang paglalarawan.",
    fields_changed: "Na-update ang mga field ng ticket ({{count}}).",
    tags_changed_added: "Mga tag na idinagdag: {{added}}.",
    tags_changed_removed: "Mga tag na inalis: {{removed}}.",
    tags_changed_both: "Mga tag na idinagdag: {{added}}; inalis: {{removed}}.",
    due_changed: "Napalitan ang takdang petsa.",
    site_changed: "Napalitan ang site.",
    sla_attached: "Inilapat ang patakaran ng SLA.",
    sla_recomputed: "Kinalkula ulit ang mga orasan ng SLA.",
    sla_warning: "Babala ng SLA: malapit na sa limitasyon ang isang target.",
    sla_breached: "Lumampas ang SLA: lumampas sa limitasyon ang isang target.",
    follow_up_opened: "Binuksan ang follow-up ticket na {{number}}.",
    ticket_reopened: "Binuksan ulit ang ticket.",
    collaborator_added: "Sinusubaybayan na ni {{name}} ang ticket.",
    collaborator_removed: "Tumigil si {{name}} sa pagsubaybay sa ticket.",
    csat_requested: "Humingi ng rating sa kliyente.",
    csat_received: "Nag-rate ang kliyente ng {{score}} / 5.",
    csat_skipped: "Walang hininging rating para sa ticket na ito.",
    notify_client_email: "Nagpadala ng e-mail sa kliyente.",
    notify_client_batched: "Isinama sa pila ang e-mail sa kliyente.",
    ticket_returned_to_queue: "Ibinalik sa pila dahil walang kumuha.",
    ticket_merged_source: "Pinagsama sa {{into}} (kinopya ang {{count}} mensahe).",
    ticket_merged_target: "Pinagsama ang {{from}} sa ticket na ito (kinopya ang {{count}} mensahe).",
    link_added: "Na-link ang {{from}} at {{to}}.",
    link_removed: "Inalis ang link ng {{from}} at {{to}}.",
    macro_applied: "Inilapat ang macro na “{{title}}”.",
    participant_added: "May idinagdag na kalahok.",
    participant_removed: "May inalis na kalahok.",
    sharing_changed: "Nagbago ang pagbabahagi sa organisasyon.",
    spam_marked: "Minarkahang spam.",
    spam_cleared: "Inalis ang marka ng spam.",
    ticket_deleted: "Binura ang ticket.",
    ticket_restored: "Naibalik ang ticket.",
    timer_unassigned_due: "Wala pa ring may-ari pagkatapos ng takdang paghihintay.",
    timer_waiting_reminder: "Nagpadala ng paalala: hinihintay ang kliyente.",
    timer_pending_expired: "Napakatagal na hinintay ang kliyente.",
    timer_auto_close_due: "Dumating na ang oras ng awtomatikong pagsasara.",
    other: "Aktibidad: {{type}}",
  },
  composer: {
    label: "Sagutin ang kliyente o magdagdag ng note",
    modes: "Sagot o internal note",
    reply: "Sagot",
    note: "Internal note",
    message: "Mensahe",
    replyPlaceholder: "Sumulat ng sagot kay {{name}}…",
    notePlaceholder: "Magdagdag ng internal note. I-@mention ang kasamahan para maabisuhan siya.",
    to: "Para kay {{name}} <{{email}}> · {{channel}} + e-mail",
    noteTo: "Staff lang ang makakakita ng note na ito. Gamitin ang @ para mag-mention ng kasamahan.",
    clientFilipino: "Wika ng kliyente: Filipino",
    unverifiedWarn: "Hindi pa verified ang humihiling. Sa {{email}} lang mapupunta ang sagot mo at walang detalye ng order o asset.",
    channel: { widget: "Widget", webapp: "Web app", mobile: "Mobile app", messenger: "Messenger", email: "E-mail", api: "API", console: "Console" },
    tools: { bold: "Bold", italic: "Italic", list: "May bullet na listahan", link: "Link" },
    macros: "Mga macro",
    attach: "Mag-attach",
    attachInput: "Pumili ng mga file na ia-attach",
    mention: "Mag-mention ng kasamahan",
    mentionLabel: "Mention (sa mga internal note lang)",
    mentionNoteOnly: "Gumagana ang mention sa mga internal note",
    sends: "nagpapadala",
    sendReply: "Ipadala ang sagot",
    addNote: "Idagdag ang note",
    sendAnd: "Ipadala at itakda ang status",
    sendAndLabel: "Ipadala ang sagot at…",
    replyAndSet: "Sagot at itakda ang {{status}}",
    replyAndResolve: "Sagot at ayusin…",
    replySent: "Naipadala ang sagot",
    noteAdded: "Naidagdag ang note",
    sentMacro: "Naipadala ang sagot · inilapat ang macro na “{{title}}”",
    sentAndSet: "Naipadala ang sagot · status: {{status}}",
    errors: {
      emptyReply: "Sumulat ng sagot bago ipadala.",
      emptyNote: "Sumulat ng note bago idagdag.",
      scanning: "Hintaying matapos ang virus scan bago magpadala.",
      macroFiles: "Hindi kayang dalhin ng macro ang mga file. Alisin ang mga file, o ipadala ang sagot nang walang macro.",
    },
    offClosed: "Hindi puwedeng magsagot o magdagdag ng note sa saradong ticket.",
    offMerged: "Hindi puwedeng magsagot o magdagdag ng note sa pinagsamang ticket.",
    offPermission: "Mababasa mo ang ticket na ito pero hindi mo ito masasagot. Humingi ng pahintulot sa reply sa isang admin.",
  },
  macros: {
    title: "Mga macro",
    search: "Maghanap ng macro",
    also: "Gagawin din: {{actions}}",
    pending: "Macro: {{title}}",
    remove: "Alisin ang mga aksyon ng macro",
    missing: "Walang halaga para sa {{variables}}: iniwang blangko, punan ito",
    inserted: "Naipasok ang macro: {{title}}",
    emptyTitle: "Wala pang macro",
    emptyBody: "Ang mga macro ay mga naka-save na sagot. Idagdag ang mga ito sa Mga setting ng Serbisyo.",
    noMatchTitle: "Walang tumutugmang macro",
    noMatchBody: "Subukan ang salita mula sa pamagat o sa shortcut nito.",
    errorTitle: "Hindi namin ma-load ang mga macro",
    action: {
      set_status: "itakda ang status",
      set_priority: "itakda ang priyoridad",
      set_type: "itakda ang uri",
      add_tags: "magdagdag ng tag",
      remove_tags: "mag-alis ng tag",
      assign: "magtalaga",
      add_note: "magdagdag ng note",
      set_field: "magtakda ng field",
    },
  },
  attach: {
    list: "Mga file na ipapadala kasama ng mensahe",
    uploading: "Ina-upload {{percent}}%",
    scanning: "Sina-scan…",
    clean: "Malinis",
    blocked: "Na-block",
    failed: "Hindi naipadala",
    blockedBody: "Na-block ang file na ito para sa seguridad.",
    failedBody: "Hindi natapos ang pag-upload. Subukan ulit.",
    retry: "Subukan ulit",
    remove: "Alisin ang {{name}}",
    refused: {
      count: "Hanggang 10 file ang puwedeng dalhin ng isang mensahe.",
      type: "Hindi tinatanggap ang ganitong uri ng file. Gumamit ng larawan, PDF, text, CSV o MP4 na video.",
      size: "Lampas na sa {{max}} MB ang file na ito.",
      empty: "Walang laman ang file na ito.",
    },
  },
  resolve: {
    title: "Ayusin ang {{number}}",
    body: "Magiging {{status}} ang status. Hihilingin sa kliyente na kumpirmahin.",
    code: "Resolution code",
    codeChoose: "Pumili…",
    codeOptional: "Opsyonal para sa ganitong uri ng ticket.",
    note: "Tala ng resolusyon",
    noteHint: "Ang ginawa para maayos ito. Makikita ito ng kliyente kapag inabisuhan mo siya.",
    notePlaceholder: "Ang ginawa para maayos ito",
    notify: "Abisuhan ang kliyente",
    notifyHint: "Ipapadala ang tala sa kliyente bilang sagot. Pagkatapos, hihilingin ng mga workflow mo na kumpirmahin nila at mag-rate.",
    force: "Ayusin kahit bukas pa ang mga child ticket",
    submit: "Ayusin",
    submitNotify: "Ayusin at abisuhan",
    done: "Naayos ang {{number}}",
    errors: {
      code: "Pumili ng resolution code.",
      note: "Isulat ang ginawa para maayos ito.",
      field: "Kailangan ang field na ito para maayos ang ticket.",
      children: "Bukas pa ang mga child ticket ng ticket na ito. Isara muna ang mga iyon, o ayusin pa rin kung may pahintulot ka.",
    },
  },
  cancel: {
    title: "Isara bilang kinansela",
    body: "Para lang sa mga duplicate, binawing kahilingan, spam o labas sa saklaw.",
    reason: "Dahilan",
    note: "Tala",
    keepOpen: "Iwanang bukas",
    submit: "Isara ang ticket",
    done: "Isinara ang {{number}} bilang kinansela",
    errors: { code: "Pumili ng dahilan." },
  },
  assign: {
    title: "Italaga ang {{number}}",
    body: "Pumili ng team, tapos ng tao. Maaabisuhan ang bagong may-ari.",
    me: "Italaga sa akin",
    queue: "Ibalik sa pila",
    team: "Team",
    noTeam: "Walang team",
    person: "Tao",
    nobody: "Walang tao (ang pila)",
    limited: "Maitatalaga mo ang ticket sa sarili mo o maibabalik sa pila. Kailangan ang pahintulot na makita ang team para pumili ng iba.",
    note: "Tala para sa bagong may-ari",
    notePlaceholder: "Opsyonal. Idadagdag bilang internal note.",
    submit: "Italaga",
    done: "Naitalaga ang {{number}} kay {{name}}",
    returned: "Bumalik sa pila ang {{number}}",
  },
  merge: {
    title: "Pagsamahin ang mga ticket",
    body: "Hindi na mababawi ang pagsasama. Dapat parehong hindi pa naaayos ang dalawang ticket at galing sa iisang organisasyon.",
    direction: "Direksyon",
    intoThis: "Isama ang ibang ticket sa {{number}}",
    thisInto: "Isama ang {{number}} sa ibang ticket",
    search: "Maghanap ng ticket",
    searchHint: "Mag-type ng hindi bababa sa {{min}} karakter ng numero o pamagat nito.",
    choose: "Pumili ng ticket",
    none: "Walang malamang na duplicate. Maghanap ayon sa numero o pamagat.",
    likely: "Malamang na duplicate",
    blocked: { organisation: "Ibang organisasyon", resolved: "Naayos na" },
    preview: {
      copied_one: "{{count}} mensahe mula sa {{from}} ang kokopyahin sa {{into}} bilang naka-quote na bloke.",
      copied_other: "{{count}} mensahe mula sa {{from}} ang kokopyahin sa {{into}} bilang naka-quote na bloke.",
      participant: "Idadagdag sa {{into}} bilang kalahok ang humihiling ng pinagsamang ticket.",
      closed: "Isasara ang {{from}} na may resolusyong Duplicate at ituturo sa {{into}}.",
      irreversible: "Hindi na ito mababawi.",
    },
    understood: "Naiintindihan kong hindi na ito mababawi.",
    submit: "Pagsamahin ang mga ticket",
    done: "Pinagsama ang {{from}} sa {{into}}",
  },
  link: {
    title: "Mag-link ng ticket",
    body: "Makikita ang link sa dalawang ticket.",
    relation: "Ugnayan",
    search: "Maghanap ng ticket",
    results: "Mga tumutugmang ticket",
    submit: "I-link ang mga ticket",
    done: "Na-link sa {{number}}",
    removed: "Inalis ang link sa {{number}}",
    errors: { ticket: "Pumili ng ticket na ili-link." },
    kinds: { related_to: "May kaugnayan sa", duplicate_of: "Duplicate ng", caused_by: "Sanhi ng (tracker)", blocks: "Humaharang sa", blocked_by: "Hinaharangan ng" },
    relations: {
      related_to: "may kaugnayan sa",
      duplicate_of: "duplicate ng",
      duplicated_by: "dinuplicate ng",
      caused_by: "sanhi ng",
      causes: "nagdudulot ng",
      blocks: "humaharang sa",
      blocked_by: "hinaharangan ng",
      follow_up_of: "follow-up ng",
      followed_up_by: "sinundan ng",
    },
  },
  stale: {
    title: "Nagbago ang ticket na ito",
    subtitle: "May nag-save ng mga pagbabago habang nag-e-edit ka.",
    by: "Nag-save si {{name}} ng mga pagbabago {{when}}.",
    byUnknown: "May nag-save ng mga pagbabago ngayon lang.",
    hint: "I-reload para makita ang pinakabagong bersyon, o magpatuloy sa pag-e-edit: mananatili ang tinype mo at gagamitin ng susunod mong pag-save ang kasalukuyang bersyon.",
    keep: "Panatilihin ang mga pagbabago ko",
    reload: "I-reload ang ticket",
  },
  ctx: {
    label: "Konteksto ng ticket",
    requester: {
      title: "Humihiling at organisasyon",
      email: "E-mail",
      mobile: "Mobile",
      role: "Papel sa org",
      sees: "Nakikitang ticket",
      filipino: "Filipino",
      manager: "Account manager",
      openTickets: "Mga bukas na ticket",
      openCount: "{{count}} ({{others}} pa)",
      contractStub: "Wala pang kontratang naitala",
      noOrganisation: "Wala pang organisasyon. I-link ang humihiling sa isang contact para makita ang organisasyon, kontrata at mga asset niya.",
      roles: { org_admin: "admin ng organisasyon", member: "miyembro" },
      visibility: { own: "sarili niya", organisation: "ng organisasyon" },
      sentiment: { label: "Tono ng kliyente", negative: "Naiinis o galit", neutral: "Neutral", positive: "Masaya o nagpapasalamat" },
    },
    links: {
      title: "Mga naka-link na item",
      none: "Wala pang naka-link.",
      error: "Hindi namin ma-load ang mga link.",
      remove: "Alisin ang link sa {{number}}",
    },
    details: {
      title: "Mga detalye, tag at katuwang",
      type: "Uri",
      team: "Team",
      channel: "Channel",
      created: "Ginawa",
      updated: "Na-update",
      language: "Wika",
      english: "English",
      tags: "Mga tag",
      noTags: "Wala pang tag.",
      addTag: "Magdagdag ng tag",
      add: "Idagdag",
      tagInvalid: "Gumamit ng maliliit na titik, numero at gitling, hanggang {{max}} karakter.",
      tagLimit: "Hanggang {{max}} tag lang ang puwede sa isang ticket.",
      tagAdded: "Naidagdag ang tag na “{{tag}}”",
      tagRemoved: "Naalis ang tag na “{{tag}}”",
      tagRemove: "Alisin ang tag na {{tag}}",
      due: "Takdang petsa",
      dueHint: "Opsyonal, hiwalay sa SLA.",
      dueSet: "Naitakda ang takdang petsa sa {{date}}",
      dueCleared: "Naalis ang takdang petsa",
      collaborators: "Mga katuwang",
      nobody: "Wala pa",
      addColleague: "Magdagdag ng kasamahan…",
      collaboratorRemove: "Alisin si {{name}} bilang katuwang",
    },
    fields: {
      title: "Mga field ng ticket",
      none: "Walang custom na field ang {{type}}. Idagdag ang mga ito sa mga setting ng uri ng ticket.",
      save: "I-save ang mga field",
      saved: "Na-save ang mga field",
      invalid: "Hindi balido ang sagot na ito.",
      error: "Hindi namin ma-load ang mga field ng ganitong uri ng ticket.",
      requiredOnResolve: "kailangan para maayos",
    },
    csat: {
      title: "CSAT",
      stars: "{{score}} sa 5 bituin",
      rated: "Nag-rate {{when}}",
      asked: "Humingi ng rating. Wala pang sagot.",
      skipped: "Walang hiningi na rating para sa ticket na ito.",
      pending: "Hihingi ng rating kapag naayos na ang ticket.",
      info: "Hihingi ng rating na 1 hanggang 5 bituin sa humihiling kapag naayos na ang ticket.",
    },
  },
} as const;
